export const webSettingsConstants = {
    WEB_SETTINGS_GET_PENDING: 'WEB_SETTINGS_GET_PENDING',
    WEB_SETTINGS_GET_FULFILLED: 'WEB_SETTINGS_GET_FULFILLED',
    WEB_SETTINGS_GET_REJECTED: 'WEB_SETTINGS_GET_REJECTED',

    WEB_SETTINGS_UPDATE_PENDING: 'WEB_SETTINGS_UPDATE_PENDING',
    WEB_SETTINGS_UPDATE_FULFILLED: 'WEB_SETTINGS_UPDATE_FULFILLED',
    WEB_SETTINGS_UPDATE_REJECTED: 'WEB_SETTINGS_UPDATE_REJECTED',

    WEB_SETTINGS_UPDATE_CLEAR: 'WEB_SETTINGS_UPDATE_CLEAR',
};

// Servisin tanidigi ayar anahtarlari. Yeni ayar eklerken hem burasi hem
// backend'deki whitelist guncellenir; boylece ekranlar arasi isim kaymasi olmaz.
export const WEB_SETTING_KEYS = {
    // Sag alt kosedeki WhatsApp butonu (myweb: onPageWhatsappIcon)
    WHATSAPP_ENABLED: 'whatsapp_enabled',
    WHATSAPP_PHONE: 'whatsapp_phone',

    // Telefon butonu (myweb: onPagePhoneIcon) — numara bos ise tesis telefonu kullanilir
    PHONE_BUTTON_ENABLED: 'phone_button_enabled',
    PHONE_BUTTON_NUMBER: 'phone_button_number',

    // Uclu yuzen butonlar (myweb: tripleFloatingButtons) — yalnizca ana sayfada gorunur.
    // Her buton hem kendi anahtari acik hem numarasi/koordinati varsa basilir.
    TRIPLE_BUTTONS_ENABLED: 'triple_buttons_enabled',
    TRIPLE_WHATSAPP_ENABLED: 'triple_whatsapp_enabled',
    TRIPLE_WHATSAPP_NUMBER: 'triple_whatsapp_number',
    TRIPLE_DIRECTION_ENABLED: 'triple_direction_enabled',
    TRIPLE_PHONE_ENABLED: 'triple_phone_enabled',
    TRIPLE_PHONE_NUMBER: 'triple_phone_number',
};
